import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { NgxsModule } from "@ngxs/store";
import { FeatureToggleState } from "./state/feature-toggle.state";
import { FeatureToggleService } from "./service/feature-toggle.service";

@NgModule({
  imports: [CommonModule, NgxsModule.forFeature([FeatureToggleState])],
  providers: [FeatureToggleService]})
export class FeatureToggleModule {}
